<template>
  <App>
      <AppBar>
        <div class="flex-wrap" style="font-size:16px;"><GroupMenu /> {{ready?group.name:'加载中...'}} <BaseTag style="margin-left:10px;">{{group.type=='dep'?'部门':'项目'}}</BaseTag></div>
        <div class="flex-wrap">
          <IconTabs :items="views" :actived="view" @on-click="handleTabEvent" />

          <IconButton title="更多模块" style="margin-left:3px" icon="ios-arrow-down"   @on-click="showMenu = !showMenu" v-if="mods.length > 4" />

        </div>
        <div class="flex-wrap split5">
          <AppAvatar />
        </div>
      </AppBar>
      <AppClient style="overflow:hidden">
        <AppMask v-if="!ready" />
        <keep-alive>
        <router-view></router-view>
      </keep-alive>
        </AppClient>
  </App>
</template>

<script>
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppRight from '@/components/app/right';
import AppClient from '@/components/app/client';
import AppAvatar from '@/components/app/avatar';
import IconButton from '@/components/app/IconButton';
import IconTabs from '@/components/app/tabs';
import AppLeft from '@/components/app/left';
import AppMask from '@/components/app/mask';
import GroupMenu from '@/components/group/GroupMenu';
import {mapGetters} from 'vuex';
export default {
  data() {
    return {
      ready: false,
      mods: [{
        key: 'cm',
        name: '资料归档',
        icon: 'md-archive',
      }],
      optionMods: [],
    };
  },
  name: 'groups',
  routerOption: {
    as_frame: true,
    as_object: true,
  },
  components: {App, AppBar, AppLeft, AppRight, AppClient, AppAvatar, IconButton, IconTabs, AppMask, GroupMenu},
  watch: {
    $route: {
      handler(v) {
        this.ready = false;
        if (!this.id || (this.group && this.group.id == this.id)) {
          this.ready = true;
          return;
        }

        this.ready = false;
        const path = 'group/load';
        this.$api.afterLogin(()=>{
          this.$store.dispatch(path, this.id).then((res)=>{
            if (this.views.length > 0 && this.views.find((v)=>this.view == v.key) == null) {
              this.RouteTo(`/core/groups/${this.id}/${this.views[0].key}`);
            }
            this.ready = true;
          });
        });
      },
      deep: true,
      immediate: true,

    },
  },
  computed: {
    ...mapGetters('session', ['session']),
    ...mapGetters('group', ['group']),
    isConcerned() {
      return this.session?.concerned?.includes(this.id);
    },
    id() {
      return this.$route.params.id;
    },
    view() {
      if (this.$route && this.id) {
        const path = this.$route.path;
        const startIndex = path.indexOf(this.id)+this.id.length+1;
        let key = path.slice(startIndex);
        if (key.includes('/')) {
          key = key.slice(0, key.indexOf('/'));
        }
        return key;
      } else {
        return '';
      }
    },
    views() {
      if (this.group.mods) {
        return this.group.mods;
      }
      const _views = [

        ...(this.group.mods || [])];
      return _views;
    },
  },
  methods: {
    handleTabEvent(e) {
      const fullpath = `/core/groups/${this.id}/${e}`;
      this.RouteTo(fullpath);
    },
    toggleFocused() {
      this.$store.dispatch('session/toggleFocused', this.id);
    },
  },
};
</script>

<style lang="less" scoped>

</style>
